import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomersPageSettingsService {

  constructor() { }

  public stringYes = 'Yes';
  public stringNo = 'No';
  public stringAllYes = 'Yes (All)';
  public stringAllNo = 'No (All)';

  private blockedFilterFunction = (data: Array<any>, filterString: String) => {
    if (filterString === this.stringAllYes) {
      return data.filter(item => item.Blocked === this.stringYes);
    }
    if (filterString === this.stringAllNo) {
      return data.filter(item => item.Blocked === this.stringNo);
    }
    return data.filter(item => item.BlockReason === filterString);
  }

  public columns: Array<any> = [
    {
      title: 'Customer Name',
      name: 'Name',
      cellClassName: ['btn-link cursor-pointer'],
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by customer'
      },
      width: '320px'
    },
    {
      title: 'Latest Request',
      name: 'LatestRequest.Date',
      cellClassName: ['btn-link cursor-pointer'],
      type: 'date',
      sort: 'desc',
      filtering: {
        filterType: 'daterange',
        maxDate: new Date(),
        placeholder: 'Filter by date'
      },
      width: '180px'
    },
    {
      title: 'Status',
      name: 'LatestRequest.State',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by status'
      }
    },
    {
      title: 'Serial Number',
      name: 'SerialNumber',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by serial'
      },
      width: '200px'
    },
    {
      title: 'Blocked',
      name: 'Blocked',
      cellClassName: ['btn-link cursor-pointer'],
      sort: false,
      filtering: {
        filterType: 'select',
        filterData: [],
        placeholder: 'Filter by blocked',
        filterFn: this.blockedFilterFunction
      },
      toolTipProperty: 'BlockReason',
      width: '90px'
    },
    {
      title: 'Online',
      name: 'OnlineSite',
      sort: false,
      filtering: {
        filterType: 'select',
        filterData: [this.stringYes, this.stringNo],
        placeholder: 'Filter by site'
      },
      toolTipProperty: 'OnlineSiteInfo',
      width: '90px'
    },
    {
      title: 'ML Version',
      name: 'MLVersion',
      sort: false,
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by ML version'
      },
      width: '90px'
    },
    {
      title: 'SF Verified',
      name: 'Verified',
      sort: false,
      filtering: {
        filterType: 'select',
        filterData: [this.stringYes, this.stringNo]
      },
      width: '90px'
    }
  ];

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    className: ['table-striped', 'table-bordered'],
    filtering: { filterString: '' },
    selectable: true
  };

  public groupsFilterData: Observable<Array<any>>;
  public selectedGroups: Array<any> = [];
  public selectedCustomers: Array<any> = [];
}
